// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__0pBsY","active":"Modal_active__b67dA","modal":"Modal_modal__6mKSp"};